import React from "react";
import "./AboutUs.css";
import { Helmet } from "react-helmet";
import aboutData from "../../shared/data/aboutData.json";
import { useCursor } from "../../shared/config/cursorProvider";

// const TeamMember = ({ imgSrc, name, role }) => (
//   <div className="about-team">
//     <img src={imgSrc} alt="" className="team-img" />
//     <h4>{name}</h4>
//     <p>{role}</p>
//   </div>
// );

const About = () => {
  const { sections } = aboutData;
  const cursorPosition = useCursor()
  const metaDescription = sections[0]?.paragraph || "Default meta description";
  return (
    <div className="about-us">
      <Helmet>
        <meta name="description" content={metaDescription} />
      </Helmet>
      <div className="custom-1" style={{ left: cursorPosition.x, top: cursorPosition.y }}></div>
      <div className="custom-cursor" style={{ left: cursorPosition.x, top: cursorPosition.y }}></div>
      <div className="success-symphony">
        <h1 className="meet-us">
          <span className="testimony">Welcome to Zivotix: </span>
          Where Digital Dreams Become Reality
        </h1>
        {sections.map(
          (section, index) =>
            section.title === "successSymphony" && (
              <p key={index}>{section.paragraph}</p>
            )
        )}
      </div>

      <div className="members-of-team">
        {sections.map((section, index) => {
          if (section.title === "ourApproach") {
            return (
              <div key={index}>
                <h1 className="meet-us">{section.header}</h1>
                <p className="about-desc">{section.paragraph}</p>
              </div>
            );
          }
          return null;
        })}
      </div>

      <div className="success-symphony">
        <h1 className="meet-us">
          Our Success Symphony:{" "}
          <span className="testimony">Passion in Every Note</span>
        </h1>
        {sections.map(
          (section, index) =>
            section.title === "successSymphony2" && (
              <p key={index}>{section.paragraph}</p>
            )
        )}
      </div>
      <div className="why-us">
        <h1>Why Choose Zivotix?</h1>
        <div className="why-choose-us">
          {sections.map((section, index) => {
            if (section.title === "whyUs") {
              return section.points.map((point, pointIndex) => (
                <div className="why-us-content" key={pointIndex}>
                  <h3>{point.title}</h3>
                  <p>{point.description}</p>
                </div>
              ));
            }
            return null;
          })}
        </div>
      </div>
    </div>
  );
};

export default About;
